import { motion } from "framer-motion";
import { Linkedin, Globe, Radio } from "lucide-react";

const mediaItems = [
  { name: "African Diaspora News Network", icon: Radio },
  { name: "LinkedIn Featured", icon: Linkedin },
  { name: "EdTech Innovator", icon: Globe },
  { name: "AI Leadership Voice", icon: Radio },
  { name: "Future of Work Expert", icon: Globe },
  { name: "Serial Entrepreneur", icon: Linkedin },
];

export default function MediaMarquee() {
  return (
    <section
      className="py-6 border-y border-primary/20 bg-card/50 overflow-hidden"
      data-testid="media-marquee"
      id="media"
    >
      <div className="relative">
        <div className="flex animate-marquee">
          {[...mediaItems, ...mediaItems].map((item, index) => (
            <div
              key={index}
              className="flex items-center gap-3 px-12 opacity-40 hover:opacity-100 transition-opacity duration-500"
            >
              <item.icon size={18} className="text-primary" />
              <span className="text-sm font-semibold uppercase tracking-wider text-muted-foreground whitespace-nowrap">
                {item.name}
              </span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
